module.exports = __webpack_public_path__ + "static/media/SF UI Display Semibold.b2c3ff41.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-UI-Display/SF UI Display Semibold.woff2
// module id = 214
// module chunks = 0